<template>
  <table class="matrix">
    <tr>
      <td class="leftp" :rowspan="matrix.rows+2"></td>
      <td class="dummy" :rowspan="matrix.rows+2"></td>
      <td class="dummy" :colspan="matrix.aug > 0 ? matrix.cols+1 : matrix.cols"></td>
      <td class="dummy" :rowspan="matrix.rows+2"></td>
      <td v-if="config.show2 != 'eqn'" class="rightp" :rowspan="matrix.rows+2"></td>
    </tr>
    <tr v-for="(row,i) of rows" :key="'row' + i" ref="row" class="row" :style="sty[i]">
      <template v-for="(e,j) of row">
	<td v-if="j == matrix.aug" :key="'aug' + i + '_' + j" class="aug" :class="cls(i,-1)">
	  {{ config.show2 == 'eqn' ? '=' : '|' }}
	</td>
	<td v-if="config.show2 == 'eqn'" :key="'ecol' + i + '_' + j"  :class="cls(i,j)">
	  {{ coeff(i,j) }}
	  <Variable v-if="variable(i,j)" :config="config" :index="j"></Variable>
	</td>
	<td v-else :key="'col' + i + '_' + j"  :class="cls(i,j)">
	  {{ e.toFraction() }}
	</td>
      </template>
      <td v-if="mark[i] != ''" :class="cls(i,-1)">
	{{ mark[i] }}
      </td>
    </tr>
    <tr>
      <td class="dummy" :colspan="matrix.aug > 0 ? matrix.cols+1 : matrix.cols"></td>
    </tr>
  </table>
</template>

<script>
import { Config, Operation, zero, one, minus } from '@/lib/base.js';
import { Matrix } from '@/lib/reduce.js';
import Variable from '@/components/Variable.vue'

export default {
  name: 'Showmatrix',
  components: {
    Variable
  },
  props: {
    matrix: Matrix,
    op: {type:Operation, default:null},
    config: Config,
    moving: Boolean,
    hint: Boolean,
    delay: Number
  },
  data: function(){
    return {
      phase: 0,
      rows: this.matrix.matrix.slice(),
      sty: new Array(this.matrix.rows).fill(''),
      mark: new Array(this.matrix.rows).fill(''),
      dy: 0,
    }
  },
  methods: {
    animInit(){
      if(this.moving){
	for(const i in this.rowList){
	  this.$set(this.sty,i,`z-index: 10; transition: all ${this.delay}ms ease; transform: scale(1)`);
	}
	this.$nextTick(this.animZoom);
      }
    },
    animZoom(){
      if(this.moving){
	if(this.op.type == 'mult'){
	  this.$set(this.mark,this.op.mult_i,'✕ ' + this.op.coeff_mult.frac.toFraction());
	  this.$set(this.sty,this.op.mult_i,`z-index: 10; transition: all ${this.delay}ms ease; transform: scale(1.5)`);
	}else if(this.op.type == 'swap'){
	  const i = this.op.swap_i1 < this.op.swap_i2 ? this.op.swap_i1 : this.op.swap_i2;
	  const j = this.op.swap_i1 < this.op.swap_i2 ? this.op.swap_i2 : this.op.swap_i1;
	  this.$set(this.mark,i,'↓');
	  this.$set(this.mark,j,'↑');
	  this.$set(this.sty,i,`z-index: 20; transition: all ${this.delay}ms ease; top: 0px; transform: scale(1.5)`);
	  this.$set(this.sty,j,`z-index: 10; transition: all ${this.delay}ms ease; top: 0px; transform: scale(1.5)`);
	}else{
	  this.$set(this.mark,this.op.add_i1,'✕ ' + this.op.coeff_add.frac.toFraction());
	  this.$set(this.sty,this.op.add_i1,`z-index: 20; transition: all ${this.delay}ms ease; transform: scale(1.5)`);
	  this.$set(this.sty,this.op.add_i2,`z-index: 10; transition: all ${this.delay}ms ease; transform: scale(1.5)`);
	}
	setTimeout(this.animMove,this.delay);	  
      }
    },
    animMove(){
      if(this.moving){
	if(this.op.type == 'mult'){
	  this.$set(this.rows,this.op.mult_i,this.matrix.tmpRows[0].slice());
	  this.$set(this.mark,this.op.mult_i,'');	  
	}else if(this.op.type == 'swap'){
	  this.$set(this.sty,this.op.swap_i1,
		    `z-index: 20; transition: all ${this.delay}ms ease; top: ${this.dy}px; transform: scale(1.5)`);
	  this.$set(this.sty,this.op.swap_i2,
		    `z-index: 10; transition: all ${this.delay}ms ease; top: ${-this.dy}px; transform: scale(1.5)`);
	}else{
	  this.$set(this.rows,this.op.add_i1,this.matrix.tmpRows[0].slice());
	  this.$set(this.mark,this.op.add_i1,this.dy > 0 ? '↓ +' : '↑ -');
	  this.$set(this.sty,this.op.add_i1,
		    `z-index: 20; transition: all ${this.delay}ms ease; transform: translate(0px,${this.dy}px) scale(1.5); opacity:0.8;`);
	}
	setTimeout(this.animUnzoom,this.delay);
      }
    },
    animUnzoom(){
      if(this.moving){
	if(this.op.type == 'mult'){
	  this.$set(this.sty,this.op.mult_i,`z-index: 10; transition: all ${this.delay}ms ease; transform: scale(1)`);
	}else if(this.op.type == 'swap'){
	  this.$set(this.mark,this.op.swap_i1,'');
	  this.$set(this.mark,this.op.swap_i2,'');
	  this.$set(this.sty,this.op.swap_i1,
		    `z-index: 20; transition: all ${this.delay}ms ease; top: ${this.dy}px; transform: scale(1)`);
	  this.$set(this.sty,this.op.swap_i2,
		    `z-index: 10; transition: all ${this.delay}ms ease; top: ${-this.dy}px; transform: scale(1)`);
	}else{
	  this.$set(this.rows,this.op.add_i1,this.matrix.matrix[this.op.add_i1]);
	  this.$set(this.rows,this.op.add_i2,this.matrix.tmpRows[1]);
	  this.$set(this.mark,this.op.add_i1,'');
	  this.$set(this.sty,this.op.add_i1,'');
	  this.$set(this.sty,this.op.add_i2,`z-index: 20; transition: all ${this.delay}ms ease; transform: scale(1)`);
	}
	setTimeout(this.animFinish,this.delay);
      }
    },
    animFinish(){
      if(this.moving){
	this.$emit('finish');
      }
    },
    coeff(i,j){
      const f = this.rows[i][j];
      if(j == this.matrix.cols -1){
	return f.toFraction();
      }else if(j == this.matrix.cols - 2 && this.rows[i].slice(0,this.matrix.cols-1).every( e => e.equals(zero))){
	return '0';
      }else if(f.equals(zero)){
	return '';
      }else{	
	let sign = f.s > 0 ? ( this.rows[i].findIndex( (e) => ! e.equals(zero) ) == j ? '' : '+ ') : '- ';	
	if(f.equals(one) || f.equals(minus)){
	  return sign;
	}else if(f.d > 1){
	  return sign + '(' + f.abs().toFraction() + ')';
	}else{
	  return sign + f.abs().toFraction();
	}
      }      
    },
    variable(i,j){
      return j < this.matrix.cols -1 && ! this.rows[i][j].equals(zero)
    },
    cls(i,j){
      const ar = [];
      if(this.op != null){
	if(this.op.type == 'mult' && (i == this.op.mult_i || i == this.matrix.rows)){
	  ar.push('s1');
	}else if(this.op.type == 'swap' && ( i == this.op.swap_i1 || i == this.op.swap_i2 || i >= this.matrix.rows) ){
	  ar.push('s2');
	}else if(this.op.type == 'add'){
	  if( i == this.op.add_i1 || i == this.matrix.rows){
	    ar.push('s3');
	  }else if( i == this.op.add_i2 || i == this.matrix.rows){
	    ar.push('s1');
	  }
	}
      }
      if(this.hint && ! this.moving && this.matrix.hint != null){
	const hint = this.matrix.hint;
	if(i == hint.r1 && j == hint.c1){
	  ar.push('h1');
	}
	if(i == hint.r2 && j == hint.c2){
	  ar.push('h2');
	}
      }
      return ar.join(' ');
    }
  },
  computed: {
    rowList(){
      if(this.op.type == 'mult'){
	return [this.op.mult_i];
      }else if(this.op.type == 'swap'){
	return [this.op.swap_i1, this.op.swap_i2];
      }else{
	return [this.op.add_i1, this.op.add_i2];
      }	
    }
  },
  watch: {
    matrix(){
      this.rows = this.matrix.matrix.slice();
      this.phase = 0;
    },
    moving(to){
      if(to){
	this.matrix.beforeApply(this.op);
	if(this.op.type == 'swap'){
	  const box1 = this.$refs.row[this.op.swap_i1].getBoundingClientRect();
	  const box2 = this.$refs.row[this.op.swap_i2].getBoundingClientRect();
	  this.dy = box2.top - box1.top;
	}else if(this.op.type == 'add'){
	  const box1 = this.$refs.row[this.op.add_i1].getBoundingClientRect();
	  const box2 = this.$refs.row[this.op.add_i2].getBoundingClientRect();
	  this.dy = box2.top - box1.top;
	}
	this.animInit();
      }else{
	this.rows = this.matrix.matrix.slice();
	this.sty = new Array(this.matrix.rows).fill('');
	this.mark = new Array(this.matrix.rows).fill('');
	this.phase = 0;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.s1 {
    background-color: #fdd;
    border-left-color: #fdd;
    border-right-color: #fdd;
}
.s2 {
    background-color: #dfd;
    border-left-color: #dfd;
    border-right-color: #dfd;
}
.s3 {
    background-color: #ddf;
    border-left-color: #ddf;
    border-right-color: #ddf;
}
.h1 {
    border-color: #f66;
}
.h2 {
    border-color: #ff0;
}
.row {
    position:relative;
}
</style>
